<div class="container-wrapper">
  <div class="container" cdkDropListGroup>
    <!-- Draggable Items List -->
    <nz-card class="items-card" nzTitle="Items & Price">
      <div cdkDropList [cdkDropListData]="filterItems" class="items-list">
        <div *ngFor="let item of filterItems" cdkDrag class="draggable-item">
          <div style="width: 200px;">
            <span class="name">{{ item.name }}</span>
          </div>
          <div style="width: 50px;text-align: right;">
            <span class="price">${{ item.price }}</span>
          </div>
          <div style="width: 50px;text-align: right;">
            <span class="price">
              <nz-icon nzType="minus-square" *ngIf="item.status==1" nzTheme="twotone" />
              <nz-icon nzType="up-circle" *ngIf="item.status==2" nzType="up-circle" nzTheme="twotone"
                [nzTwotoneColor]="'#52c41a'" />
              <nz-icon *ngIf="item.status==3" nzType="down-circle" nzTheme="twotone" [nzTwotoneColor]="'#ff4d4f'" />
            </span>
          </div>
          
        </div>
      </div>
    </nz-card>

    <!-- Selected Items List -->
    <nz-card class="cart-card" nzTitle="Publish Price" [nzExtra]="extraTemplate">
      <div cdkDropList [cdkDropListData]="selectedItems" (cdkDropListDropped)="drop($event)" class="selected-list">
        <div *ngFor="let selectedItem of selectedItems; let i = index" class="selected-item">
          <div style="width: 100px;">
            <span class="name">{{ selectedItem.name }}</span>
          </div>
          <div style="width: 100px;">
            <span class="price min-w-[100px]">${{ selectedItem.price }}</span>
          </div>
          <div style="width: 30px;">
            <span class="min-w-[30px]"><nz-icon nzType="minus-square" *ngIf="selectedItem.status==1" nzTheme="twotone" />
              <nz-icon nzType="up-circle" *ngIf="selectedItem.status==2" nzType="up-circle" nzTheme="twotone"
                [nzTwotoneColor]="'#52c41a'" />
              <nz-icon *ngIf="selectedItem.status==3" nzType="down-circle" nzTheme="twotone" [nzTwotoneColor]="'#ff4d4f'" /></span>
          </div>
          <button nz-button nzType="link" nzSize="small" (click)="removeItem(i)">Remove</button>
        </div>
      </div>
    </nz-card>
  </div>
  <ng-template #extraTemplate>
    <button nz-button nzType="primary" (click)="publishPrices()">
      <span nz-icon nzType="save" nzTheme="outline"></span>
      Publish
    </button>
  </ng-template>

</div>